import { useNavigate } from 'react-router-dom'
import { Shield, LogOut } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { useAuthStore } from '@/lib/auth'

/**
 * Full-page courtesy screen shown to non-admin users when the tenant's
 * subscription is expired/canceled. They cannot manage billing themselves,
 * so they need to contact their administrator.
 */
export function SubscriptionExpired() {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  const logout = useAuthStore((s) => s.logout)

  return (
    <div className="flex min-h-svh flex-col items-center justify-center bg-muted p-6">
      <div className="w-full max-w-sm text-center space-y-6">
        <div className="flex items-center justify-center">
          <div className="w-16 h-16 rounded-2xl bg-amber-100 flex items-center justify-center">
            <Shield className="w-8 h-8 text-amber-600" />
          </div>
        </div>
        <div className="space-y-2">
          <h1 className="text-xl font-semibold tracking-tight">
            {t('subscriptionExpired.title')}
          </h1>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {t('subscriptionExpired.description')}
          </p>
        </div>
        <Button
          variant="outline"
          className="w-full"
          onClick={async () => { await logout(); navigate('/login') }}
        >
          <LogOut className="h-4 w-4 mr-1.5" />
          {t('nav.logout')}
        </Button>
      </div>
    </div>
  )
}
